export default __webpack_public_path__ + "images/MW.1f7ebad.png";